import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

/**
 * Tells the native app whether the page was rendered for a signed in user, so the app can swap between its tab
 * bar and its sign in screen however the page was reached (a server redirect never produces a visit proposal).
 * Does nothing in a browser. Attach it with data-controller="bridge--session" and
 * data-bridge--session-state-value="signed_in" or "signed_out".
 */
export default class SessionController extends BridgeComponent {
  public static component = 'session';
  public static values = { state: String };
  declare private readonly stateValue: string;

  public connect(): void {
    this.send('state', { signedIn: this.stateValue === 'signed_in' });
  }
}
